import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./css/Navbar.css";
import LanguageSwitcher from "../components/LanguageSwitcher";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={require("../assets/image/logo.png")} alt="logo" />
      </div>

      {/* Hamburger */}
      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      {/* Nav Links */}
      <ul className={`nav-links ${isOpen ? "active" : ""}`}>
        <li>
          <NavLink to="/home" className={({ isActive }) => isActive ? "active-link" : ""}>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" className={({ isActive }) => isActive ? "active-link" : ""}>
            About us
          </NavLink>
        </li>
        <li>
          <NavLink to="/trips" className={({ isActive }) => isActive ? "active-link" : ""}>
            Trips
          </NavLink>
        </li>
        <li>
          <NavLink to="/gallery" className={({ isActive }) => isActive ? "active-link" : ""}>
            Gallery
          </NavLink>
        </li>
        <li>
          <NavLink to="/careers" className={({ isActive }) => isActive ? "active-link" : ""}>
            Careers
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" className={({ isActive }) => isActive ? "active-link" : ""}>
            Contact
          </NavLink>
        </li>

        {/* Show Language Switcher inside menu (on mobile) */}
        <li className="mobile-lang">
          <LanguageSwitcher />
        </li>
      </ul>

      {/* Show Language Switcher on desktop */}
      
        <div className='desktop-lang'>
          <LanguageSwitcher />
        </div>
    </nav>
  );
};

export default Navbar;
